import { render, staticRenderFns } from "./AssemblyGlobalSettings.vue?vue&type=template&id=178dc159&"
import script from "./AssemblyGlobalSettings.vue?vue&type=script&lang=js&"
export * from "./AssemblyGlobalSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports